import api from "./api";

const PassportService = {
  async book(data) {
    const r = await api.post("/passport", data);
    return r.data;
  },
  async list(email) {
    const r = await api.get("/passport", { params: { email } });
    return r.data;
  },
  async getOne(id) {
    const r = await api.get(`/passport/${id}`);
    return r.data;
  },
  async cancel(id) {
    const r = await api.post(`/passport/${id}/cancel`);
    return r.data;
  },
};

export default PassportService;
